import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordClientDataClassName = DataClassName.TIMERECORD_CLIENT
const timerecordClientEndpoint = PisaDataClassEndpoint.TIMERECORD_CLIENT

export function pisaTimerecordClientDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordClientDataClassName, {
    title: timerecordClientDataClassName,
    restApi: createPisaRestApiConfig(timerecordClientEndpoint),
    attributes,
  })
}
